import { render, staticRenderFns } from "./what-to-pack-a45.vue?vue&type=template&id=455ae7bc"
import script from "./what-to-pack-a45.vue?vue&type=script&lang=js"
export * from "./what-to-pack-a45.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports